import React, { useState, useEffect, useCallback, useMemo } from 'react';
import CouponModalStyled from './CouponModalStyled';
import {
  TextField,
  IconButton,
  Box,
  Button,
  useTheme,
} from '@material-ui/core';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'dva';
import SearchIcon from '@material-ui/icons/Search';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useIntl } from 'umi';
import { Controller } from 'react-hook-form';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { control } = props;
  const theme = useTheme();
  const [allCpList, setAllCpList] = useState([]);
  const [defaultCouponList, setDefaultCouponList] = useState([]);
  const [refreshTime, setRefreshTime] = useState();
  const dispatch = useDispatch();
  const { setOpen = () => {}, onConfirm, couponList } = props;
  useEffect(() => {
    if (couponList && couponList.length > 0) {
      setDefaultCouponList(couponList);
      setSelectedCouponList(couponList);
    }
  }, []);

  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });

  const couponIdList = useMemo(() => {
    return couponList?.map((i) => i.id);
  }, [couponList]);

  const [selectedCouponList, setSelectedCouponList] = useState([]);

  const [couponTitle, setCouponTitle] = useState();

  const fetchCouponList = useCallback(() => {
    dispatch({
      type: 'cpList/getCpList',
      payload: {
        values: {
          title: couponTitle,
          pageNum: pageData.pageNum,
          pageSize: pageData.pageSize,
          status: 'NOT_COMPLETE',
        },
      },
    });
  }, [dispatch, pageData.pageNum, pageData.pageSize, refreshTime]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  const { data: cpList, total } =
    useSelector((state) => state.cpList?.cpList) || {};

  useEffect(() => {
    if (cpList?.length > 0) {
      setAllCpList([...allCpList, ...cpList]);
    }
  }, [cpList, setAllCpList]);
  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b, c) => {
        const currentId = b.id;
        let Index = -1;
        defaultCouponList.map((i, index) => {
          if (i.id === currentId) {
            Index = index;
          }
        });
        const copyDefaultCouponList = [...defaultCouponList];
        if (Index >= 0) {
          copyDefaultCouponList.splice(Index, 1);
          setDefaultCouponList([...copyDefaultCouponList]);
        }

        // const pageDataIds = cpList.map((item) => item.id); //当前分页的id数组
        //根据id 筛选出最新选中的值
        function unique(arr) {
          return Array.from(new Set(arr));
        }
        //去重一下
        const uAllCpList = unique(allCpList);
        //去重一下
        let z = [];
        for (let i = 0; i < c.length; i++) {
          const cpItem = uAllCpList.find((item) => item.id === c[i].id);
          cpItem.givenNum = '1';
          if (cpItem) {
            z.push(cpItem);
          }
        }
        // const z = x.filter((i) => y.find((item) => item.id === i));

        const t = [...z, ...copyDefaultCouponList];

        function unique1(arr) {
          for (let i = 0; i < arr.length; i++) {
            for (let j = i + 1; j < arr.length; j++) {
              if (arr[i].id === arr[j].id) {
                //第一个等同于第二个，splice方法删除第二个
                arr.splice(j, 1);
                j--;
              }
            }
          }
          return arr;
        }
        const array = unique1(t);
        setSelectedCouponList(array);
      },
    },
    {
      title: '优惠券ID',
      align: 'left',
      id: 'id',
      key: 'id',
      width: 145,
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl03' }),
      align: 'left',
      id: 'title',
      key: 'title',
      width: 145,
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl04' }),
      id: 'isAllGoods',
      width: 145,
      align: 'center',
      key: 'isAllGoods',
      render: ({ isAllGoods }) => {
        switch (isAllGoods) {
          case 0:
            return '指定适用商品';
          case 1:
            return '所有商品';
          case 2:
            return '不适用商品';
          default:
            return '';
        }
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl05' }),
      align: 'center',
      id: 'subTitle',
      key: 'subTitle',
      width: 145,
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl06' }),
      align: 'center',
      id: 'memberLimit',
      key: 'memberLimit',
      width: 135,
      render: ({ memberLimit }) => {
        return <div>{memberLimit ? '不限' : '会员'}</div>;
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl07' }),
      align: 'center',
      id: 'isLimitMaxCoupons',
      key: 'isLimitMaxCoupons',
      width: 125,
      render: ({ isLimitMaxCoupons }) => {
        return <div>{isLimitMaxCoupons ? '限制' : '不限'}</div>;
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl08' }),
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      width: 145,
    },
    //赠券数
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    onConfirm(selectedCouponList);
    setOpen(false);
  };

  return (
    <CouponModalStyled theme={theme}>
      <Box ml={3} className="coupon-name-wrap">
        <Controller
          render={(pr) => (
            <TextField
              className="coupon-name"
              variant="standard"
              onChange={(e) => {
                setCouponTitle(e.target.value);
                return pr.onChange(e.target.value);
              }}
              value={pr.value || couponTitle}
              label={''}
              placeholder={formatMessage({
                id: 'marketing.people.regnotcon.d01.placeholder01',
              })}
              InputProps={{
                endAdornment: (
                  <IconButton
                    type="submit"
                    aria-label="search"
                    onClick={() => {
                      setPageData({
                        pageNum: 1,
                        pageSize: pageData.pageSize,
                      });
                      const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
                      setRefreshTime(time);
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          )}
          control={control}
          name="couponTitle"
          rules={{
            required: true,
            maxLength: {
              value: 20,
            },
          }}
        />
      </Box>
      <div className="coupon-list">
        <DataTableNativeML
          columns={columns}
          changePage={changePage}
          page={pageData}
          data={cpList}
          total={total}
          devicesMinWidth="auto"
          chooseIds={couponIdList}
          paging={true}
          columnKey="id"
        ></DataTableNativeML>
      </div>
      <div className="modal-btn-wrap">
        <Button onClick={handleClose} variant="contained" color="secondary">
          {formatMessage({ id: 'comm.action.btn.08' })}
        </Button>
        <Button
          variant="contained"
          type="submit"
          className="btnSubmit button"
          onClick={onSubmit}
        >
          {formatMessage({ id: 'comm.action.btn.07' })}
        </Button>
      </div>
    </CouponModalStyled>
  );
};
